var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoradnaPriFinancniTisni = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 104,
  height: 25,
  fill: "none",
  viewBox: "0 0 104 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M0 24.165h23.547V.527H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.032 17.637c-1.579-1.025-1.63-1.854-1.63-1.854v1.664S3.2 19.03 6.058 20.39s5.882.389 6.852.055c1.282-.441 2.912-1.71 2.912-3.071v-1.867s-.068.909-1.428 1.929c-.915.685-2.521 1.402-4.818 1.402-2.11 0-3.644-.615-4.544-1.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.438 11.589c-1.578-1.026-1.63-1.854-1.63-1.854v1.664s-.202 1.58 2.656 2.942c2.858 1.36 5.882.389 6.852.055 1.282-.44 2.913-1.71 2.913-3.07V9.457s-.069.91-1.43 1.929c-.914.685-2.52 1.403-4.817 1.403-2.111 0-3.644-.615-4.544-1.201"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.079 5.77C3.5 4.742 3.449 3.914 3.449 3.914v1.664S3.245 7.16 6.104 8.522c2.858 1.36 5.881.389 6.851.055 1.283-.441 2.913-1.71 2.913-3.072V3.638s-.068.91-1.429 1.93c-.914.685-2.52 1.402-4.817 1.402-2.111 0-3.644-.615-4.544-1.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M34.231 4.444c.823 0 1.209.042 1.587.168.646.21 1.04.834 1.04 1.618 0 .8-.428 1.424-1.09 1.617-.32.085-.68.118-1.436.118h-.336v2.099h-1.074v-5.62zm.11 2.603c.62 0 .763-.017.973-.093.277-.1.445-.379.445-.733 0-.337-.143-.598-.378-.724-.21-.101-.437-.135-.99-.135h-.395v1.685z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M42.348 7.25c0 .952-.277 1.735-.814 2.249-.437.43-1.05.674-1.704.674-.672 0-1.285-.236-1.72-.674-.547-.522-.815-1.289-.815-2.292 0-.901.294-1.702.814-2.199.445-.438 1.058-.674 1.712-.674 1.528 0 2.527 1.163 2.527 2.915m-3.937-.026c0 1.272.53 2.022 1.41 2.022.874 0 1.41-.758 1.41-1.988 0-1.239-.537-1.997-1.41-1.997-.864 0-1.41.758-1.41 1.963"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M44.706 4.444c.99 0 1.368.059 1.754.27.504.269.798.808.798 1.457 0 .733-.336 1.264-.99 1.559l1.284 2.334H46.3l-1.142-2.149h-.772v2.149h-1.075v-5.62zm.067 2.553c.529 0 .713-.017.915-.093.302-.11.479-.388.479-.742a.74.74 0 0 0-.362-.657c-.218-.126-.377-.143-1.108-.143h-.31v1.635z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m50.658 4.444 1.905 5.62h-1.116l-.345-1.172H49.13l-.353 1.172h-1.1l1.89-5.62zm-.546 1.238-.714 2.292h1.436z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M54.687 4.444c.83 0 1.342.084 1.745.286.831.421 1.335 1.374 1.335 2.52 0 1.086-.462 2.055-1.2 2.468-.487.278-.873.346-2.049.346h-1.2v-5.62zm.2 4.701c.622 0 .899-.059 1.176-.261.378-.278.604-.902.604-1.643 0-.742-.235-1.323-.638-1.61-.327-.227-.545-.269-1.402-.269h-.235v3.783z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m59.892 4.444 2.267 3.96v-3.96h1.023v5.62H62.1l-2.334-3.96v3.96h-1.024v-5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m66.833 4.444 1.906 5.62h-1.117l-.344-1.172h-1.972l-.353 1.172h-1.1l1.89-5.62zm-.545 1.238-.714 2.292h1.436z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M34.231 14.586c.823 0 1.209.042 1.587.169.646.21 1.04.834 1.04 1.617 0 .801-.428 1.424-1.09 1.618-.32.084-.68.118-1.436.118h-.336v2.098h-1.074v-5.62zm.11 2.604c.62 0 .763-.017.973-.093.277-.101.445-.379.445-.733 0-.337-.143-.598-.378-.725-.21-.1-.437-.134-.99-.134h-.395v1.685z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M39.057 14.586c.991 0 1.369.06 1.755.27.503.27.797.809.797 1.457 0 .734-.336 1.264-.99 1.56l1.284 2.333h-1.25l-1.142-2.148h-.773v2.148h-1.074v-5.62zm.89-.505h-.831l-1.158-1.189h.982l.587.658.588-.658h.982zm-.822 3.058c.528 0 .713-.017.914-.092.303-.11.479-.388.479-.742a.74.74 0 0 0-.36-.657c-.22-.127-.379-.143-1.109-.143h-.31v1.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M42.617 20.206h1.075v-5.62h-1.075z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M50.432 16.836v.918h-2.225v2.452h-1.074v-5.62h3.517v.918h-2.443v1.332z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M51.48 20.206h1.075v-5.62H51.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m55.048 14.586 2.266 3.96v-3.96h1.025v5.62h-1.083l-2.334-3.96v3.96h-1.024v-5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m61.99 14.586 1.905 5.62H62.78l-.344-1.171h-1.973l-.352 1.171h-1.1l1.889-5.62zm-.546 1.239-.713 2.292h1.435z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m65.8 14.586 2.266 3.96v-3.96h1.025v5.62h-1.083l-2.334-3.96v3.96H64.65v-5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M73.573 16.415c-.11-.65-.47-1.003-1.041-1.003-.83 0-1.351.767-1.351 1.997s.52 1.98 1.36 1.98c.654 0 1.007-.413 1.074-1.264h.957c-.067 1.45-.739 2.19-1.99 2.19-.662 0-1.25-.227-1.695-.64-.546-.522-.823-1.28-.823-2.258 0-1.02.311-1.828.89-2.359a2.34 2.34 0 0 1 1.578-.581c1.192 0 1.897.69 1.973 1.938zm-.605-2.334h-.83l-1.159-1.189h.982l.588.658.587-.658h.983z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m76.613 14.586 2.266 3.96v-3.96h1.024v5.62H78.82l-2.333-3.96v3.96h-1.024v-5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M82.304 12.8h1.191l-1.452 1.373h-.906zm-1.058 7.406v-5.62h1.074v5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M89.22 14.586v.918h-1.477v4.702h-1.075v-4.701h-1.477v-.919z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M91.042 12.8h1.192l-1.452 1.373h-.907zm-1.058 7.406v-5.62h1.075v5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M94.986 16.238c-.042-.523-.378-.826-.915-.826-.462 0-.814.261-.814.615 0 .168.1.32.285.421.16.084.16.084.924.388.965.396 1.091.463 1.326.708.252.252.386.615.386 1.036 0 1.062-.772 1.736-1.998 1.736-1.376 0-2.132-.7-2.182-2.022h1.04q.104 1.086 1.15 1.086c.53 0 .89-.244.89-.598 0-.219-.125-.396-.386-.539-.142-.084-.142-.084-.965-.421-.638-.27-.949-.455-1.15-.674a1.43 1.43 0 0 1-.394-1.02c0-.969.788-1.651 1.913-1.651.689 0 1.285.27 1.62.75.194.27.277.547.303 1.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "m98.295 14.586 2.266 3.96v-3.96h1.024v5.62h-1.083l-2.333-3.96v3.96h-1.025v-5.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M102.928 20.206h1.074v-5.62h-1.074z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .528h104v23.636H0z"
})))));
export default SvgPoradnaPriFinancniTisni;